import { useParams } from "react-router-dom";
import { useGetTaskQuery } from "../../features/tasks/tasksApi";
import Form from "./Form";
export default function EditTaskForm() {
  const { taskId } = useParams();
  const { data: task, isLoading, isError } = useGetTaskQuery(taskId);
  let content = null;

  if (isLoading) content = <h1>Loading...</h1>;

  if (!isLoading && isError) content = <h1> There was an error! </h1>;

  if (!isLoading && !isError && task?.id) {
    content = <Form key={task.id} task={task} />;
  }

  return <>{content} </>;
}
